export interface Condition {
    "$ICondition": string;
}

export interface Action {
    "$IAction": string;
}

export interface Rule {
    id: string;
    conditions: Condition[];
    action: Action;
    ordinal: number;
    description: string | null;
}

export interface RuleUIModel {
    conditions: RuleUICondition[];
    action: RuleUIAction;
}

export enum RuleUICondition {
    Unknown = 0,
    Always = 1,
    Contains = 2,
    DoesNotContain = 3,
    TitleLengthLtE = 4,
    TitleLengthGtE = 5,
    TitleLengthExact = 6
}

export enum RuleUIAction {
    Unknown = 0,
    InsertAt = 1,
    Remove = 2,
    Replace = 3,
    DropChars = 4
}